// settings
// https://swiperjs.com/swiper-api
/*
    <div
        data-controller="swiper"
        class="swiper" 
        data-carousel-options-value="{ }"
    >
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div>Slide 1</div>
            </div>
            <div class="swiper-slide">
                <div>Slide 2</div>
            </div>
            <div class="swiper-slide">
                <div>Slide 3</div>
            </div>
        </div>

        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
*/

import {
    Controller
} from "@hotwired/stimulus"
import Swiper from 'swiper';
import {
    Autoplay,
    Navigation,
    Pagination,
    EffectFade
} from 'swiper/modules'
//https://swiperjs.com/migration-guide-v10

export default class extends Controller {
    static values = {
        options: Object,
        type: String
    }

    connect() {
        if (this.element.swiper) {
            this.element.swiper.destroy(true, true)
        }

        const typeOptions = this.typeValue === "brand-gallery" ? this.brandGalleryOptions : this.optionsValue;
        const config = {
            modules: [Autoplay, Navigation, Pagination, EffectFade],
            ...this.defaultOptions,
            ...typeOptions
        };
        this.swiper = new Swiper(this.element, config);
    }

    disconnect() {
        if (this.swiper) {
            this.swiper.destroy(true, true)
            this.swiper = null
        }
    }

    get brandGalleryOptions() {
        return {
            slidesPerView: 1,
            spaceBetween: 0,
            slidesPerGroup: 1,
            pagination: false,
            breakpoints: {
                768: {
                    slidesPerView: 3
                }
            }
        }
    }

    get defaultOptions() {
        return {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 1000,
            loop: true,
            pagination: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        }
    }
}